<template>
  <div>
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <div class="about">
      <div class="main-content">
        <!-- title and content -->
        <div class="page-width pre-formatted padding">
          <div class="section-header text-center">
            <h2>{{ $t('companyInformationTitle') }}</h2>
          </div>
          <h4>{{ $t('companyInformationFirst') }}</h4>
          </br>
          <p v-html="$t('companyInformationBody')"></p>
          </br>
          </br>
          <p>{{ $t('address') }}: 514 W Ohio Ave, Richmond, CA 94804</p>
        </div>
        <!-- image -->
        <!-- <div class="pre-formatted">
          <ul>
            <li>
              <img src="../../assets/img/WHS1.jpg" alt=""/>
            </li>
            <li>
              <img src="../../assets/img/WHS2.jpg" alt=""/>
            </li>
            <li>
              <img src="../../assets/img/WHS3.jpg" alt=""/>
            </li>
            <li>
              <img src="../../assets/img/WHS4.jpg" alt=""/>
            </li>
          </ul>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';

export default {
  name: "about",
  components: {
    breadcrumb,
  },
  data() {
    return {
      path2: this.$t('aboutUs'),
    }
  }
}
</script>

<style scoped lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/about.less";
</style>



// WEBPACK FOOTER //
// src/view/Footer/about.vue